import styled from "styled-components";

import { Wrapper } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface ProductCardDescriptionProps {
  description: string;
}

const Description = styled(Typography)`
  margin-top: 0.2rem;
  text-align: left;
  font-size: 0.9rem;
  line-height: 20px;
  height: calc(3 * 20px);
  overflow: hidden;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    height: 20px;
    width: 80%;
    background: linear-gradient(90deg, transparent, white);
  }
`;

export const ProductCardDescription = ({ description }: ProductCardDescriptionProps) => {
  return (
    <Wrapper margin="0.5rem" overflow="hidden">
      <Typography fontWeight="bold">Description:</Typography>
      <Description title={description}>{description}</Description>
    </Wrapper>
  );
};
